// Include jQuery
const $ = require('jquery');

// jQuery definitions
window.jQuery = $;
window.$ = $;

// tippy
import tippy from 'tippy.js';

// awesome-notifications
import AWN from 'awesome-notifications';

let notifier = new AWN({
  durations: {
    global: 2000, success: 2000,
  },
});

// clipboard
const ClipboardJS = require('clipboard');

/**
 * init tooltip
 */
window.initTooltip = function() {
  const types = {
    'top': '.tooltip-top',
    'right': '.tooltip-right',
    'bottom': '.tooltip-bottom',
    'left': '.tooltip-left',
  };

  Object.entries(types).forEach(entry => {
    const [key, value] = entry;

    tippy(document.querySelectorAll(value), {
      content: (reference) => reference.getAttribute('data-title'),
      allowHTML: true,
      duration: 0,
      placement: key,
      trigger: 'mouseenter focus',
    });
  });
};

/**
 * initClipboard
 */
let clipboard;
window.initClipboard = function(element) {
  if (typeof clipboard !== 'undefined') {
    clipboard.destroy();
  }

  clipboard = new ClipboardJS(element);

  clipboard.on('success', function(e) {
    // eslint-disable-next-line
    window.setAwnNotification('success', LANG_STRINGS.kopiert, LANG_STRINGS.inZwischenAblageKopiert);
    e.clearSelection();
  });

  return false;
};

/**
 * setAwnNotification
 * @param type
 * @param title
 * @param message
 */
window.setAwnNotification = function(type = 'success', title = '', message = '') {
  if (type !== '' && message !== '') {
    if (type === 'success') {
      notifier.success(message, {labels: {success: title}});
    } else if (type === 'warning') {
      notifier.warning(message, {labels: {warning: title}});
    } else if (type === 'alert') {
      notifier.alert(message, {labels: {alert: title}});
    }
  }
};

/**
 * AjaxItem
 *
 * @param item
 * @param getData
 * @param params
 * @param path
 * @constructor
 */
window.AjaxItem = function(item, getData, params, path = '') {
  if (typeof item != 'string') {
    return;
  }
  if (typeof params != 'object') {
    params = {};
  }

  getData = getData || {};
  const self = this;

  let ajaxPath = '';
  if (path !== '') {
    ajaxPath = path + '/';
  }

  const defaults = {
    container: '#list-' + item,
    // eslint-disable-next-line
    ajaxFile: BASE_PATH + 'ajax/list/' + ajaxPath + 'ajax.' + item + '?LANG=' + LANG, // Parameter hier hinzugefügt
    callback: function() {
    },
  };
  let config = $.extend(defaults, params);

  /**
   * sortBy
   * @param sortby
   */
  this.sortBy = function(sortby) {
    self.updater({sortby: sortby});
  };

  /**
   * loader
   */
  this.loader = function() {
    $.ajax({
      url: config.ajaxFile + (!$.isEmptyObject(getData) ? '&' + $.param(getData) : ''),
      beforeSend: function() {
        $(config.container).html('');
        self.showLoader();
      },
      success: function(html) {
        $(config.container).html(html);
        self.afterLoad();
      },
    });
  };

  /**
   * updater
   * @param getUpdater
   */
  this.updater = function(getUpdater) {
    let data = (typeof getUpdater != 'undefined' ? getUpdater : {});
    data = $.extend(data, {ajax: 1});

    $.ajax({
      url: config.ajaxFile + (!$.isEmptyObject(getData) ? '&' + $.param(getData) : ''),
      type: 'get',
      data: data,
      beforeSend: function() {
        self.showLoader();
      },
      success: function(html) {
        $(config.container).html(html);
        self.afterLoad();
      },
    });
  };

  /**
   * poster
   * @param postData
   */
  this.poster = function(postData) {
    let data = (typeof postData != 'undefined' ? postData : {});
    data = $.extend(data, {ajax: 1});
    $.ajax({
      url: config.ajaxFile,
      type: 'post',
      data: data,
      beforeSend: function() {
        self.showLoader();
      },
      success: function(html) {
        $(config.container).html(html);
        self.afterLoad();
      },
    });
  };

  /**
   * afterLoad
   */
  this.afterLoad = function() {
    if (typeof config.callback == 'function') {
      config.callback();
    }

    $(config.container).css({
      'minHeight': 'auto',
    });

    // Scrollbar Width neu berechnen
    _calculateScrollbarWidth();

    iOSInputFix();
  };

  /**
   * showLoader
   */
  this.showLoader = function() {
    window.insertAutoLoader($(config.container));
  };
};

/**
 * insert AutoLoader
 * @param into
 */
window.insertAutoLoader = function(into = 'body') {
  if ($(into).find('.ajax-loader').length === 0) {
    $(into).css({
      'position': 'relative',
      'minHeight': '150px',
    });
    $(into).append('<div class="ajax-loader"><div class="loader">Loading...</div></div>');
  }
};

/**
 * Remove AutoLoader
 */
window.removeAutoLoader = function() {
  const ajaxLoader = $('.ajax-loader');
  if (ajaxLoader.length > 0) {
    ajaxLoader.remove();
  }
};

/**
 * ajaxDialog
 * @param file
 * @param maxWidth
 * @param params
 * @param modalContentID
 */
window.ajaxDialog = function(file, maxWidth, params, modalContentID = '') {
  const self = $(this);
  const body = $('body');

  // Default für maxWidth des PopUps definieren
  maxWidth = maxWidth || 742;

  // Close-Icon
  const closeHtml = '<button type="button" class="btn-close" aria-label="Close" onclick="ajaxDialog(\'close\');"><i class="material-icons">close</i></button>';

  /**
   * show
   */
  self.show = function() {
    // modal backdrop
    const popUpBackDrop = $('body .modal-backdrop');
    const popupModal = $('body .modal');

    const zIndex = 1050 + popUpBackDrop.length;

    body.append('<div class="modal-backdrop" style="z-index:' + zIndex + '"></div>');
    body.append('<div class="modal" tabindex="-1"  style="z-index:' + zIndex + '"><div class="modal-dialog" style="max-width:' + maxWidth + 'px;"><div class="modal-content" ' + (modalContentID !== '' ? 'id="' + modalContentID + '"' : '') + '></div></div></div>');

    const popup = popupModal.last();

    if (typeof file == 'string') {
      // eslint-disable-next-line
      file += (file.indexOf('?') !== -1) ? '&LANG=' + LANG : '?LANG=' + LANG;

      self.loadData();
    }
    if (typeof file == 'object') {
      popup.find('.modal-content').html(file.html());
    }

    window.checkOpenDialog();
  };

  /**
   * loadData
   */
  self.loadData = function() {
    $.ajax({
      url: file,
      type: 'post',
      data: config.post_data,
      beforeSend: function() {
        window.insertAutoLoader($('body .modal').last().find('.modal-content'));
      },
      success: function(html) {
        const popup = $('body .modal').last().find('.modal-content');
        popup.html(html).find('.modal-header').append(closeHtml);

        if (popup.find('form').attr('action') === '') {
          popup.find('form:first').submit(function() {
            config.post_data = $(this).find('input:not([type=checkbox],[type=radio],[type=submit],[type=image],[type=reset]), input[type=checkbox]:checked, input[type=radio]:checked, textarea, select');

            self.loadData();
            return false;
          });
        }

        if (typeof config.callback == 'function') {
          config.callback();
        }

        iOSInputFix();
      },
    });
  };

  /**
   * close
   */
  self.close = function() {
    if (typeof overwriteClose == 'function' && typeof overwriteClose !== 'undefined') {
      overwriteClose(); // eslint-disable-line
    }

    const popUpWrap = $('body .modal');
    const popUpBackdrop = $('body .modal-backdrop');

    popUpWrap.last().remove();
    popUpBackdrop.last().remove();
    /*if (popUpWrap.length === 0) {
      popUpBackdrop.remove();
    }*/

    window.checkOpenDialog();
  };

  // Hier gehts los
  if (typeof file == 'object' && $(file).attr('href')) {
    file = $(file).attr('href');
  } else if (typeof file == 'object') {
    file = $(file);
  }

  if (file === 'close') {
    self.close();
    return;
  }

  if (typeof params != 'object') {
    params = {};
  }

  const defaults = {
    width: 0,
    callback: function() {
    },
    post_data: {},
  };
  const config = $.extend(defaults, params);

  self.show();
};

/**
 * checkOpenDialog
 */
window.checkOpenDialog = function() {
  const popupWrap = $('.modal');
  const body = $('body');
  if (popupWrap.length) {
    if (!body.hasClass('overflow-hidden')) {
      body.addClass('overflow-hidden');
    }
  } else {
    if (body.hasClass('overflow-hidden')) {
      body.removeClass('overflow-hidden');
    }
  }
};

/**
 * Formatiert die Dateigröße
 * @param bytes
 * @returns {*}
 */
window.formatFileSize = function(bytes) {
  if (typeof bytes !== 'number') {
    return '';
  }
  //if(bytes >= 1000000000) return number_format((bytes / 1000000000).toFixed(2), 1, ',', '.') + ' GB';
  if (bytes >= 1000000) {
    return window.number_format((bytes / 1000000).toFixed(2), 1, ',', '.') + ' MB';
  }
  return window.number_format((bytes / 1000).toFixed(2), 1, ',', '.') + ' KB';
};

/**
 * Number Format Funktion wie in PHP
 * @param number
 * @param decimals
 * @param dec_point
 * @param thousands_sep
 * @returns {string}
 */
window.number_format = function(number, decimals, dec_point, thousands_sep) {
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
      dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
      s,
      toFixedFix = function(n, prec) {
        var k = Math.pow(10, prec);
        return '' + Math.round(n * k) / k;
      };

  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
};

/**
 * Full-Text Function
 * @param element
 * @param identifier
 * @param listObject
 */
window.fullTextSearch = function(element, identifier, listObject) {
  $(element).on('input', function() {
    window.updateListFilter($(this), identifier, listObject);
  });
};

/**
 * updateListFilter
 * @param object
 * @param identifier
 * @param filterTimeout
 * @param listObject
 */
let filterTimeout;
window.updateListFilter = function(object, identifier, listObject) {
  const inputVal = object.val();
  clearTimeout(filterTimeout);
  filterTimeout = setTimeout(function() {
    if (listObject.length > 1) {
      $.each(listObject, function(key, value) {
        value.updater({[identifier]: inputVal});
      });
    } else {
      listObject.updater({[identifier]: inputVal});
    }
  }, 300);

  return filterTimeout;
};

/**
 * Object to form data
 * @param obj
 * @param formData
 * @returns {FormData}
 */
window.object2FormData = function(obj, formData = new FormData()) {
  const createFormData = function(obj, subKeyStr = '') {
    for (let i in obj) {
      let value = obj[i];
      let subKeyStrTrans = subKeyStr ? subKeyStr + '[' + i + ']' : i;

      if (typeof (value) === 'string' || typeof (value) === 'number') {
        formData.append(subKeyStrTrans, value);
      } else if (typeof (value) === 'object') {
        createFormData(value, subKeyStrTrans);
      }
    }
  };

  createFormData(obj);

  return formData;
};

/**
 * Init Password Toggle
 */
window.initPasswordToggle = function() {
  const passwordToggle = $('.password-toggle');

  // password toggle
  if (passwordToggle.length) {
    passwordToggle.on('click', function() {
      const toggleElement = $(this);
      if (toggleElement.closest('label').children('input').length) {
        const inputElement = toggleElement.closest('label').children('input');
        const inputType = inputElement.attr('type');
        if (inputType === 'password') {
          inputElement.attr('type', 'text');
        } else {
          inputElement.attr('type', 'password');
        }
      }
    });
  }
};

/**
 * Check pw strength
 * @param element
 * @param inputID
 */
window.checkPwStrength = function(element, inputID) {
  const field = document.getElementById(inputID);
  const value = field.value;

  if (value !== '') {
    document.querySelector(element).classList.remove('d-none');
  } else {
    document.querySelector(element).classList.add('d-none');
  }

  const successClass = 'bg-success';
  const dangerClass = 'bg-danger';

  const passwordElement = document.querySelector('#' + inputID);
  const verifyPwElement = document.querySelector(element);

  const pwRequirements = [
    {id: '#pw-length', regex: /.{8,}/},
    {id: '#pw-number', regex: /\d/},
    {id: '#pw-letter', regex: /[A-Za-z]/},
    {id: '#pw-char', regex: /[^A-Za-z0-9]/},
  ];

  // check requirements
  let allGood = true;
  pwRequirements.forEach(requirement => {
    const pwElement = verifyPwElement.querySelector(requirement.id);
    const isValid = requirement.regex.test(value);
    pwElement.classList.toggle(successClass, isValid);
    pwElement.classList.toggle(dangerClass, !isValid);

    if (!isValid) {
      allGood = false;
    }
  });

  // Passwort Input
  if (passwordElement) {
    passwordElement.classList.remove('is-invalid');
    if (passwordElement.value !== '') {
      if (allGood === false) {
        passwordElement.classList.add('is-invalid');
      }
    }
  }
};

/**
 * Check pw repeat
 */
window.checkPwRepeat = function() {
  const checkPwRepeat = $('.check-pw-repeat');
  const checkPwStrength = $('.check-pw-strength');
  $('.check-pw-repeat, .check-pw-strength').on('keyup', function() {
    if (checkPwRepeat.val() !== '' && checkPwRepeat.val() !== checkPwStrength.val()) {
      checkPwRepeat.closest('div').addClass('form-field--error');
      if (!(checkPwRepeat.closest('div').find('.error-message').length)) {
        checkPwRepeat.closest('div').append('<small class="error-message">' + LANG_STRINGS.PASSWOERTER_STIMMEN_NICHT_UEBEREIN + '</small>');
      }
    } else {
      checkPwRepeat.closest('div').removeClass('form-field--error');
      checkPwRepeat.closest('div').remove('.error-message');
    }
  });
};

// Leider wird das benötigt um Fullscreen-Breiten innerhalb des content-limiters zu erzielen.
// Die Funktion berechnet die Scrollbar Breite und setzt diese als CSS Custom Property auf das Root-Element.
window._calculateScrollbarWidth = function() {
  setTimeout(() => {
    // Leider muss ich hier einen Pixel dazu zählen, da es sonst mit dem Scrollbar flackert
    let scrollBarWidth = (window.innerWidth - document.documentElement.clientWidth + 1);
    // Bei Mobile sollte korrekterweite dann der eine Pixel wieder entfernt werden
    if (scrollBarWidth <= 1) {
      scrollBarWidth = 0;
    }
    document.documentElement.style.setProperty('--scrollbar-width', scrollBarWidth + 'px');
  }, 20);
};

// recalculate on resize
window.addEventListener('resize', _calculateScrollbarWidth, false);
// recalculate on dom load
document.addEventListener('DOMContentLoaded', _calculateScrollbarWidth, false);
// recalculate on load (assets loaded as well)
window.addEventListener('load', _calculateScrollbarWidth);
